export const SEATS_RANGE_OPTIONS = [
    {value: null, caption: '', title: 'Unlimited'},
    {value: 100, caption: '0 - 100', title: '0 - 100'},
    {value: 500, caption: '101 - 500', title: '101 - 500'},
    {value: 1000, caption: '501 - 1000', title: '501 - 1000'},
    {value: 9999, caption: '1000+', title: '1000+'},
];

export function getSeatsRangeValue(count?: number | null): number | null {
    if (count == null) {
        return null;
    }
    return [100, 500, 1000].find(limit => count <= limit) ?? 9999;
}

export function getSeatsRangeTitle(count?: number | null): {caption: string, title: string} {
    const value = getSeatsRangeValue(count);
    const option = SEATS_RANGE_OPTIONS.find(o => o.value === value);
    return {caption: option?.caption ?? '', title: option?.title ?? ''};
}

import {LicenseType} from 'src/openapi/admin/models/LicenseType';

/**
 * License types that are prohibited for creation/modification
 */
export const PROHIBITED_LICENSE_TYPES_FOR_CREATION: ReadonlySet<LicenseType> = new Set([
    LicenseType.IR, // Investor Relations License
    LicenseType.CU, // Concurrent Users License
]);

/**
 * Determines if a license type is prohibited for creation/modification
 * @param type - The license type to check
 * @returns true if the license type is prohibited, false otherwise
 */
export const isLicenseTypeProhibitedForCreation = (
    type?: LicenseType,
): boolean => Boolean(type && PROHIBITED_LICENSE_TYPES_FOR_CREATION.has(type));

